import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import FullPage from "../elements/fullPage/fullPage";
import classes from "./Settings.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CampusSelection from "./pages/CampusSelection";
import RouteSettings from "./pages/RouteSettings";
import Language from "./pages/Language";
import DataProtection from "./pages/DataProtection";
import Event from "./pages/Event";
import * as mainAction from "../../reduxStore/actions/main";
import { MISC_INFO, MODULES } from "../../reduxStore/actions/main";
import * as settingAction from "../../reduxStore/actions/settings";
import { piKey } from "../../app/app.sideEffects/useURLParams.sideEffects";
import Calendar from "./pages/Calendar";
import Location from "./pages/Location";
import { withRouter } from "react-router-dom";
import * as actionNavigation from "../../reduxStore/actions/navigation";
import PushSettings from "./pages/Push.settings.jsx";
import { setProperties } from "../../reduxStore/actions/settings";
import { addToast } from "../../reduxStore/actions/toasts.js";
import { statisticLogger } from "../statisticLogger/StatisticLogger.container";
import { pageNames } from "../../reduxStore/reducers/main";

function Settings(props) {
  const intl = useIntl();
  const [currentPage, setCurrentPage] = useState(0);
  const [settingsAreOpen, setSettingsAreOpen] = useState(false);

  useEffect(() => {
    statisticLogger.currentPage = pageNames.settings;
    statisticLogger.addLog({
      action: {
        id: "enterSettingsPage",
        name: "Enter Settings Page",
        group: "Page",
        movement: "enter",
        type: "click",
      },
    });
  }, []);

  useEffect(() => {
    setSettingsAreOpen(props.newAvailableCampuses);
  }, [props.newAvailableCampuses]);

  if (!props.serverDataLoaded) {
    return null;
  }

  const closeSettings = () => {
    props.history.goBack();
  };

  const openSetting = (index) => {
    setCurrentPage(index);
    setSettingsAreOpen(true);
  };

  const loadCampuses = (keys) => {
    props.loadCampuses(keys, props.language, piKey);
    props.setCampusKeys(keys);
  };

  const settings = [];

  if (props.campuses.length > 1) {
    settings.push({
      name: intl.formatMessage({ id: "settings.campusSelectionTitle" }),
      text: intl.formatMessage({ id: "settings.campusSelectionText" }),
      page: "campusSelection",
    });
  }

  if (!MISC_INFO.disabledRouteSettings)
    settings.push({
      name: intl.formatMessage({ id: "settings.routeSettingsTitle" }),
      text: intl.formatMessage({ id: "settings.routeSettingsText" }),
      page: "routeSettings",
    });

  settings.push({
    name: intl.formatMessage({ id: "settings.languageSettingsTitle" }),
    text: intl.formatMessage({ id: "settings.languageSettingsText" }),
    page: "languageSettings",
  });

  const urlParams = new URLSearchParams(window.location.search);
  const isFramed = !!urlParams.get("isFramed");

  if (!isFramed)
    settings.push({
      name: intl.formatMessage({ id: "settings.locationTitle" }),
      text: intl.formatMessage({ id: "settings.locationText" }),
      page: "locationSettings",
    });

  /*{
      name: intl.formatMessage({ id: "settings.dataProtectionSettingsTitle" }),
      text: intl.formatMessage({ id: "settings.dataProtectionSettingsText" }),
      page: "dataProtectionSettings",
    },*/

  if (MODULES.hasEvents) {
    settings.push({
      name: intl.formatMessage({ id: "settings.eventSettingsTitle" }),
      text: intl.formatMessage({ id: "settings.eventSettingsText" }),
      page: "eventSettings",
    });
  }

  if (props.isApp) {
    // settings.push({
    //   name: intl.formatMessage({ id: "settings.calendarSettingsTitle" }),
    //   text: intl.formatMessage({ id: "settings.calendarSettingsText" }),
    //   page: "calendarSettings",
    // });
    settings.push({
      name: intl.formatMessage({ id: "settings.pushMessagesTitle" }),
      text: intl.formatMessage({ id: "settings.pushMessagesText" }),
      page: "pushSettings",
    });
  }
  return (
    <>
      <FullPage
        title={intl.formatMessage({ id: "settings.title" })}
        needSearch={false}
        needClose={true}
        onClose={closeSettings}
        bgClass="ca-bg-white"
      >
        <div className={`p-3`}>
          {settings.map((s, index) => (
            <div
              className={`d-flex justify-content-between ${classes.item}`}
              key={s.page}
              onClick={() => openSetting(index)}
            >
              <div>
                <h3>{s.name}</h3>
                <p>{s.text}</p>
              </div>

              <FontAwesomeIcon icon={"angle-right"} />
            </div>
          ))}
        </div>
      </FullPage>
      <div
        className={`${classes.secondPage} ${
          settingsAreOpen ? classes.active : ""
        }`}
      >
        <FullPage
          title={settings[currentPage].name}
          needSearch={false}
          needClose={false}
          needBack={true}
          onBack={() => setSettingsAreOpen(false)}
          bgClass="ca-bg-white"
        >
          <div className={"p-3 h-100"}>
            {(props.newAvailableCampus ||
              "campusSelection" === settings[currentPage].page) &&
            props.selectedCampuses.length ? (
              <CampusSelection
                close={() => setSettingsAreOpen(false)}
                loadCampuses={loadCampuses}
                selectedCampuses={props.selectedCampuses}
                text={settings[currentPage].text}
                campuses={props.campuses}
                serverDataLoaded={props.serverDataLoaded}
              />
            ) : null}
            {"routeSettings" === settings[currentPage].page ? (
              <RouteSettings
                close={() => setSettingsAreOpen(false)}
                settings={props.settings.routing}
                text={settings[currentPage].text}
                setProperties={props.setProperties}
              />
            ) : null}
            {"languageSettings" === settings[currentPage].page ? (
              <Language
                close={() => setSettingsAreOpen(false)}
                language={props.language}
                text={settings[currentPage].text}
                setLanguage={props.setLanguage}
                loadCampuses={loadCampuses}
                selectedCampuses={props.selectedCampuses}
              />
            ) : null}
            {"dataProtectionSettings" === settings[currentPage].page ? (
              <DataProtection
                close={() => setSettingsAreOpen(false)}
                settings={props.settings.dataProtection}
                text={settings[currentPage].text}
                setProperties={props.setProperties}
              />
            ) : null}
            {"eventSettings" === settings[currentPage].page ? (
              <Event
                close={() => setSettingsAreOpen(false)}
                settings={props.settings.event}
                text={settings[currentPage].text}
                setProperties={props.setProperties}
              />
            ) : null}
            {"calendarSettings" === settings[currentPage].page ? (
              <Calendar
                close={() => setSettingsAreOpen(false)}
                settings={props.settings.calendar}
                text={settings[currentPage].text}
                setProperties={props.setProperties}
              />
            ) : null}
            {"locationSettings" === settings[currentPage].page ? (
              <Location
                close={() => setSettingsAreOpen(false)}
                text={settings[currentPage].text}
                userAllowedGPS={props.userAllowedGPS}
                setUserAllowedGPS={props.setUserAllowedGPS}
                setHasLatestLocation={props.setHasLatestLocation}
                isApp={props.isApp}
                location={props.location}
                addToast={props.addToast}
                properties={props.properties}
                setProperties={props.setProperties}
                locationObject={props.locationObject}
                locationPermissionAllowed={props.locationPermissionAllowed}
                setLocationPermissionAllowed={
                  props.setLocationPermissionAllowed
                }
                setGPSData={props.setGPSData}
              />
            ) : null}
            {"pushSettings" === settings[currentPage].page ? (
              <PushSettings
                permissionAllowed={props.pushMessagesSettings.permissionAllowed}
                userAllowed={props.pushMessagesSettings.userAllowed}
                setSettingsProperties={props.setProperties}
              />
            ) : null}
          </div>
        </FullPage>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    isApp: state.main.isApp,
    language: state.main.language,
    selectedCampuses: state.main.campusKeys,
    campuses: state.main.availableCampuses,
    settings: state.settings,
    userAllowedGPS: state.settings.location.userAllowed,
    locationPermissionAllowed: state.settings.location.permissionAllowed,
    serverDataLoaded: state.main.serverDataLoaded,
    pushMessagesSettings: state.settings.pushMessages,
    location: state.settings.location,
    locationObject: state.route.locationObject,
    properties: state.settings,
    newAvailableCampuses: state.main.newAvailableCampuses,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadCampuses: (keys, lang, piKey) =>
      dispatch(mainAction.loadCampuses(keys, lang, piKey)),
    setCampusKeys: (keys) => dispatch(mainAction.setCampusKeys(keys)),
    setProperties: (properties) =>
      dispatch(settingAction.setProperties(properties)),
    setLanguage: (key) => dispatch(mainAction.setLanguage(key)),
    setUserAllowedGPS: (allowed) =>
      dispatch(setProperties({ location: { userAllowed: allowed } })),
    addToast: (toast) => dispatch(addToast(toast)),
    setHasLatestLocation: (value) =>
      dispatch(actionNavigation.setHasLatestLocation(value)),
    setPage: (page) => dispatch(mainAction.setPage(page)),
    updateFilter: () => dispatch(settingAction.updateFilter()),
    setCalendarAllowed: (value) =>
      dispatch(settingAction.setCalendarAllowed(value)),
    setLocationPermissionAllowed: (value) =>
      dispatch(setProperties({ location: { permissionAllowed: value } })),
    setGPSData: (object) => dispatch(actionNavigation.setGPSData(object)),
    setSettingsProperties: (object) =>
      dispatch(settingAction.setProperties(object)),
  };
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Settings)
);
